import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import OvertimeRequest, { IOvertimeRequest } from 'modules/attendance/store/models/OvertimeRequest'

class OvertimeRequests extends Collection<OvertimeRequest> {
  constructor(data: IOvertimeRequest[] = []) {
    super(data)
    makeObservable(this, {
      approved: computed,
      pending: computed,
    })
  }

  get cacheKey(): string {
    return 'overtimeRequests'
  }

  model() {
    return OvertimeRequest
  }

  get indexes() {
    return ['employee_id', 'date', 'status']
  }

  get approved(): OvertimeRequest[] {
    return this.filter({
      status: 'approved',
    })
  }

  get pending(): OvertimeRequest[] {
    return this.filter({
      status: 'pending',
    })
  }

  byEmployee(employeeId: number): OvertimeRequest[] {
    return this.filter({ employee_id: employeeId })
  }
}

const singleton: OvertimeRequests = new OvertimeRequests()

export default singleton
